//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import ExportSIEFormContainer from "./exportSIEFormContainer";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useSIEFileExportDialog(onActionSuccess?: () => void): DialogProps {
  return {
    isOpen: false,
    title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.ExportSIEFile),
    titleIcon: IconDefinitionConstants.WDocument,
    actions: [
      {
        text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Export),
        successMessage: TranslationKeys.Document.SIEFileExported,
      },
    ],
    dialogType: DialogEnums.DialogType.Content,
    children: <ExportSIEFormContainer />,
    maxWidth: "sm",
    onSubmit: onActionSuccess,
  };
}

export default useSIEFileExportDialog;
